import { log as pilog } from "@limitless/common/utils";
const RELEASE_TOPIC = "flo-users-release";
const CACHE_TOPIC = `flo-resource-cache-${process.env.REACT_APP_WS_STAGE}`;
const MESSAGES_TOPIC = `flo-messages-${process.env.REACT_APP_WS_STAGE}`;
let wsSubscriptions = {};
const handleSubscription = (topic, result) => {
  const log = pilog.getLogger("WebSocketHelper handleSubscription");
  try {
    let status = "success";
    if (result !== null && result !== void 0 && result.errorMessage) {
      status = result.errorMessage;
      log.warn("Web Socket topic subscription error %o", result);
    }
    wsSubscriptions = {
      ...wsSubscriptions,
      [topic]: status
    };
  } catch (e) {
    log.warn("Error handling web socket topic subscription %o", e);
  }
};
const handleUnsubscription = topic => {
  const log = pilog.getLogger("WebSocketHelper handleUnsubscription");
  try {
    Reflect.deleteProperty(wsSubscriptions, topic);
  } catch (e) {
    log.warn("Error handling web socket topic unsubscription %o", e);
  }
};
const getSubscribeOptions = topic => ({
  onSuccess: result => handleSubscription(topic, result),
  onFailure: result => handleSubscription(topic, result)
});
const getUnSubscribeOptions = topic => ({
  onSuccess: result => handleUnsubscription(topic, result),
  onFailure: result => handleUnsubscription(topic, result)
});
export const getWebSocketSubscriptionStatus = () => {
  return wsSubscriptions;
};
export const subscribeToUserChannel = (client, profile) => {
  const log = pilog.getLogger("WebSocketHelper subscribtToUserChannel");
  const userTopic = `flo-users-${process.env.REACT_APP_WS_STAGE}-${profile.userName}`;
  log.debug("Subscribing to ", userTopic);
  client.subscribe(userTopic, getSubscribeOptions(userTopic));
  const userRoleTopic = `flo-users-${process.env.REACT_APP_WS_STAGE}-${profile.userRole}`;
  log.debug("Subscribing to ", userRoleTopic);
  client.subscribe(userRoleTopic, getSubscribeOptions(userRoleTopic));
};
export const unsubscribeFromUserChannel = (client, profile) => {
  const userTopic = `flo-users-${process.env.REACT_APP_WS_STAGE}-${profile.userName}`;
  client.unsubscribe(userTopic, getUnSubscribeOptions(userTopic));
  const userRoleTopic = `flo-users-${process.env.REACT_APP_WS_STAGE}-${profile.userRole}`;
  client.unsubscribe(userRoleTopic, getUnSubscribeOptions(userRoleTopic));
};
export const subscribeToGroups = (client, profile) => {
  const log = pilog.getLogger("WebSocketHelper subscribeToGroups");
  client.subscribe(MESSAGES_TOPIC, getSubscribeOptions(MESSAGES_TOPIC));
  log.debug("Subscribing to ", MESSAGES_TOPIC);
  log.debug(`Subscribing to ${profile.groups.length} groups`);
  profile.groups.map(group => {
    const groupTopic = `flo-groups-${process.env.REACT_APP_WS_STAGE}-${group.groupName}`;
    client.subscribe(groupTopic, getSubscribeOptions(groupTopic));
    log.debug("Subscribing to ", groupTopic);
  });

  // subscribe to receive cache IoT events

  log.debug("Subscribing to ", CACHE_TOPIC);
  client.subscribe(CACHE_TOPIC, getSubscribeOptions(CACHE_TOPIC));
  //release topic

  client.subscribe(RELEASE_TOPIC, getSubscribeOptions(RELEASE_TOPIC));
};
export const unSubscribeGroups = (client, profile) => {
  const log = pilog.getLogger("WebSocketHelper unSubscribeGroups");
  log.debug("Unsubscribing from groups");
  client.unsubscribe(MESSAGES_TOPIC, getUnSubscribeOptions(MESSAGES_TOPIC));
  client.unsubscribe(CACHE_TOPIC, getUnSubscribeOptions(CACHE_TOPIC));
  client.unsubscribe(RELEASE_TOPIC, getUnSubscribeOptions(RELEASE_TOPIC));
  const groups = profile.groups;
  log.debug(`Unsubscribing to ${groups.length} groups`);
  if (groups.length > 0) {
    groups.map(group => {
      const groupTopic = `flo-groups-${process.env.REACT_APP_WS_STAGE}-${group.groupName}`;
      client.unsubscribe(groupTopic, getUnSubscribeOptions(groupTopic));
    });
  }
  if (client) {
    log.debug("Disconnecting from websocket client");
    try {
      client.disconnect();
    } catch (error) {
      log.info("Failed to gracefully disconnect from web sockets. ", error);
    }
  }
};
export const subscribeToSupportChannel = (client, messageId) => {
  const log = pilog.getLogger("WebSocketHelper subscribtToUserChannel");
  const messageTopic = `flo-public-${process.env.REACT_APP_WS_STAGE}-${messageId}`;
  log.debug("Subscribing to ", messageTopic);
  client.subscribe(messageTopic, getSubscribeOptions(messageTopic));
};
export const unsubscribeFromSupportChannel = (client, messageId) => {
  const messageTopic = `flo-public-${process.env.REACT_APP_WS_STAGE}-${messageId}`;
  client.unsubscribe(messageTopic, getUnSubscribeOptions(messageTopic));
};